import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 pt-[15px] pb-[15px]" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-dark-card to-dark border border-dark-border rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-162">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-brand to-transparent" data-id="element-163" />

          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand/10 mb-6" data-id="element-164">
            <ShieldCheck className="w-10 h-10 text-brand" data-id="element-165" />
          </div>

          <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-166">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-xl text-gray-300 mb-4" data-id="element-167">
            Abrís los tomos. Los aplicás en tu negocio.
          </p>
          <p className="text-xl font-bold text-white mb-8" data-id="element-168">
            Si en 7 días no es lo que esperabas:
            <br data-id="element-169" />
            <span className="text-brand" data-id="element-170">
              devolución del 100% — sin formularios, sin drama.
            </span>
          </p>

          <div className="inline-block bg-dark-border px-4 py-2 rounded-full text-sm text-gray-400 font-medium" data-id="element-171">
            Tasa de devoluciones: menos del 1%.
          </div>
        </motion.div>
      </div>
    </section>;
}